export enum VotingItemsTypesEnum {
    Standard = 1,
    Director_Exception = 2,
    Frequency_123 = 3,
    Frequency_321 = 4
}
